export enum type {
  GET_STUDENT_CERT_LIST = 'GET_STUDENT_CERT_LIST',
  GET_STUDENT_CERT_LIST_ASYNC = 'GET_STUDENT_CERT_LIST_ASYNC',
  GET_DASHBOARD_MY_PROGRESS = 'GET_DASHBOARD_MY_PROGRESS',
  GET_DASHBOARD_MY_PROGRESS_ASYNC = 'GET_DASHBOARD_MY_PROGRESS_ASYNC',
}
